export default __webpack_public_path__ + "static/media/gold-2.55d7bb46.png";